import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { AuthorizeService } from '../../lib-shared/services/authorize.service';
import { PermissionTypes } from '../vs-constants';
import { UserService } from '../services/user.service';
import { GlobalService } from '../../services/global.service';

@Injectable()
export class GuardService implements CanActivate {
    constructor(
        private _router: Router,
        private _authorizeService: AuthorizeService,
        private _userService: UserService,
        private _globalService: GlobalService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // AppComponent xử lý OAuth callback và khởi tạo quyền.
        // BehaviorSubject giúp cả lần login đầu và F5 đều chờ đúng trạng thái sẵn sàng.
        return new Promise(resolve => {
            this._globalService.userReadyPopulate()
                .pipe(
                    filter(isReady => isReady === true),
                    take(1)
                )
                .subscribe(() => resolve(this.canAccessRoute(route)));
        });
    }

    private canAccessRoute(route: ActivatedRouteSnapshot): boolean {
        if (this._userService.getBasicUserInfo().issuperuser) {
            return true;
        }

        if (!route.data || !route.data.permissionRequired
            || this._authorizeService.validated(route.data.permissionRequired, PermissionTypes.PAGE)) {
            return true;
        }

        this._router.navigate(['/error/403']);
        return true;
    }
}
